/* eslint-disable spire/export-styles */

import React, { FC } from "react";
import styled, { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

type Props = WidgetProps;

export interface HomePageSectionContainerStyles {
    maincontainer?: InjectableCss;
    container?: InjectableCss;
}

const styles: HomePageSectionContainerStyles = {
    maincontainer: {
        css: css`
            width: 100%;
            background: #f7f7f7;
        `,
    },
    container: {
        css: css`
            max-width: 1440px;
            margin: 0 auto;
            display: flex;
            justify-content: flex-end;
            & div {
                &.sectionTitle {
                    & h3 {
                        font-size: 24px;
                        font-weight: 500px;
                        color: ${getColor("secondary.main")};
                        width: 100%;
                        text-align: left;
                        border-bottom: 2px solid ${getColor("primary")};
                        line-height: 0.1em;
                        margin: 10px 0 20px;
                        & span {
                            background: #f7f7f7;
                            padding-right: 10px;
                        }
                    }
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    & h3 {
                                        border-bottom: none;
                                        font-size: 20px;
                                        line-height: 1.5;
                                    }
                                `,
                                css`
                                    & h3 {
                                        font-size: 20px;
                                    }
                                `,
                                null,
                                css`
                                    & div {
                                        &.sectionTitle {
                                            margin: 30px 3px 40px;
                                        }
                                    }
                                `,
                                null,
                            ],
                            "max",
                        )}
                }
            }

            > div[class^="Wrapper"] {
                padding: 40px 0px;
                margin: 0 auto;

                > div[class^="GridWrapper"] {
                    margin: 0 auto;
                    > div[class^="GridOffset"] {
                        > div[class^="GridItemStyle"] {
                            padding: 15px;
                            &:nth-child(2) {
                                > div[class^="Wrapper"] {
                                    &:last-child {
                                        > div[class^="ContentWrapper"] {
                                            > div[class^="parternsContent"] {
                                                font-size: 16px;
                                                color: ${getColor("secondary.main")};
                                                margin-bottom: 30px;
                                            }
                                            > div[class^="sectionButtonContainer"] {
                                                margin-top: 30px;
                                                background-color: #f7f7f7;
                                                > button[class^="sectionButton"] {
                                                    border: none;
                                                    padding: 10px;
                                                    font-size: 12px;
                                                    color: ${getColor("primary.contrast")};
                                                    background-color: #91a2a4;
                                                }
                                                ${({ theme }: { theme: BaseTheme }) =>
                                                    breakpointMediaQueries(
                                                        theme,
                                                        [
                                                            css`
                                                                > button[class^="sectionButton"] {
                                                                    padding: 5px;
                                                                }
                                                            `,
                                                            null,
                                                            null,
                                                            null,
                                                            null,
                                                        ],
                                                        "max",
                                                    )}
                                                &:hover {
                                                    button {
                                                        background-color: ${getColor("primary")};
                                                    }
                                                }
                                            }
                                        }
                                        > div[class^="GridWrapper"] {
                                            margin-top: 40px;
                                            > div[class^="GridOffset"] {
                                                > div[class^="GridItemStyle"] {
                                                    > div[class^="Wrapper"] {
                                                        > div {
                                                            margin-right: 20px;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        ${({ theme }: { theme: BaseTheme }) =>
                                            breakpointMediaQueries(
                                                theme,
                                                [
                                                    css`
                                                        > div[class^="GridWrapper"] {
                                                            margin-top: 30px;
                                                            > div[class^="GridOffset"] {
                                                                display: inline-block;
                                                                > div[class^="GridItemStyle"] {
                                                                    display: inline-block !important;
                                                                    width: 30%;
                                                                    margin-right: 5px;
                                                                    > div[class^="Wrapper"] {
                                                                        > div {
                                                                            margin-right: 20px;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    `,
                                                    null,
                                                    null,
                                                    null,
                                                    null,
                                                ],
                                                "min",
                                            )}
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
};

export const HomePageSectionContainerStyles = styles;

const HomePageSectionContainer: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.maincontainer}>
            <StyledWrapper {...styles.container}>
                <Zone contentId={id} zoneName="container" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const homePageSectionContainer: WidgetModule = {
    component: HomePageSectionContainer,
    definition: {
        group: "Common",
    },
};

export default homePageSectionContainer;
